import { Component } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import {
  DataService,
  FormInputComponent,
  SharedModule,
} from "@vendure/admin-ui/core";
import { gql } from "graphql-tag";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

const GET_CATEGORIES_FOR_SEO_SELECT = gql`
  query GetCategoriesForSeoSelect {
    globalSettings {
      customFields {
        categories
      }
    }
  }
`;

@Component({
  selector: "vdr-category-seo-category-select",
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
  template: `
    <select class="form-control" [formControl]="formControl" [disabled]="readonly">
      <option value="">Selecciona una categoría</option>
      <option *ngFor="let c of categories$ | async" [value]="c">{{ c }}</option>
    </select>
  `,
})
export class CategorySeoCategorySelectComponent implements FormInputComponent {
  readonly!: boolean;
  formControl!: FormControl;
  config!: any;

  categories$: Observable<string[]>;

  constructor(private dataService: DataService) {
    this.categories$ = this.dataService
      .query(GET_CATEGORIES_FOR_SEO_SELECT)
      .mapSingle((r: any) => r?.globalSettings?.customFields?.categories ?? [])
      .pipe(catchError(() => of([])));
  }
}
